import CareItem from '../airtable/CareItem';
import { DuoItem } from '../buruburu/care/care.ruleset';
import { inviteExpiration } from './duo.ruleset';

export function isExpiredInvitation(timestamp: number, now: number) {
  return now - timestamp > inviteExpiration;
}

export function getDuoItemReward(item: DuoItem) {
  const itemData = CareItem.find(({ id }) => id === item) as {
    reward_gems: number;
  };
  return itemData?.reward_gems;
}
